export default __webpack_public_path__ + "assets/feishu.png?78973b6b062396d84778a4bd282e6d0a";